import { DataLayerErrorType } from '../types/enums';
import { DataLayerService } from '../services/data-layer-service';

export class ErrorListener {
    private readonly _dataLayer: DataLayerService;

    constructor(dataLayer: DataLayerService) {
        this._dataLayer = dataLayer;
    }

    public init(): void {
        this._setupGlobalErrorHandler();
        this._setupConsoleErrorListeners();
    }

    private _setupGlobalErrorHandler(): void {
        window.onerror = (
            message: string | Event,
        ): boolean => {
            if (this._dataLayer) {
                const formattedMessage = typeof message === 'string' ? message : 'Unknown script error';
                this._dataLayer.error_message(formattedMessage, DataLayerErrorType.CONSOLE_ERROR);
            }

            return false; // allow default logging
        };
    }

    private _setupConsoleErrorListeners(): void {
        const originalConsoleError = console.error;

        console.error = (...args: any[]) => {
            if (originalConsoleError)
                originalConsoleError.apply(console, args);

            const formattedMessage = args
                .map(arg =>
                    typeof arg === 'string'
                        ? arg
                        : arg instanceof Error
                            ? arg.message
                            : JSON.stringify(arg)
                )
                .join(' | ');

            if (this._dataLayer)
                this._dataLayer.error_message(formattedMessage, DataLayerErrorType.CONSOLE_ERROR);
        };
    }
}